<template>
  <el-dialog :visible.sync="reportVisible" width="22%" @close="close">
    <el-form ref="reportForm" :model="reportForm" label-position="top">
      <el-form-item :label="`${$t('global.请填写举报理由')}：`">
        <el-checkbox-group v-model="reportForm.reportReasonArray">
          <el-checkbox :label="$t('global.涉及黄赌毒和暴力')" name="reason"></el-checkbox>
          <el-checkbox :label="$t('global.政治')" name="reason"></el-checkbox>
          <el-checkbox :label="$t('global.版权问题')" name="reason"></el-checkbox>
          <el-checkbox :label="$t('global.抄袭')" name="reason"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-input
          type="textarea"
          wrap="hard"
          v-model="reportForm.reportContent"
          :placeholder="$t('global.请输入举报内容，我们将尽快处理。')"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit(0)">{{$t('global.提交')}}</el-button>
      </el-form-item>
      <el-form-item>
        <p class="message">{{$t('global.也可发邮件给我们')}}：info@manamana.net</p>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
export default {
  name: "ReportDialog",
  data() {
    return {
      reportForm: {
        reportReasonArray: [],
        reportReason: "",
        reportContent: "",
        topicQuestionId: "",
        reportType: 0
      }
    };
  },
  props: {
    questionId: {
      type: Number | String
    },
    reportType: {
      type: String
    },
    reportVisible: {
      type: Boolean
    },
    item: {
      type: Object
    }
  },
  created() {},
  methods: {
    init() {
      this.reportForm = {
        reportReasonArray: [],
        reportReason: "",
        reportContent: "",
        topicQuestionId: "",
        reportType: 0,
        domainId: "",
        type: "",
        content: ""
      };
    },
    onSubmit() {
      if (this.reportType == 0) {
        this.reportForm.topicQuestionId = this.questionId;
        this.reportForm.reportType = 0;
        this.reportForm.reportReason = this.reportForm.reportReasonArray.join();
        this.$http
          .post("/api/u/topicquestion/report", this.reportForm)
          .then(response => {
            if (response.code == "OK") {
              this.$message(this.$t("global.举报成功"));
              this.close();
              this.init();
            } else {
              this.$message(this.$t("global.举报失败"));
            }
          });
      } else if (this.reportType == 1) {
        this.reportForm.topicQuestionId = this.questionId;
        this.reportForm.reportType = 1;
        this.reportForm.reportReason = this.reportForm.reportReasonArray.join();
        this.$http
          .post("/api/u/topicanswer/report", this.reportForm)
          .then(response => {
            if (response.code == "OK") {
              this.$message(this.$t("global.举报成功"));
              this.close();
              this.init();
            } else {
              this.$message(this.$t("global.举报失败"));
            }
          });
      } else if (this.reportType == 2) {
        var form = {
          domainId: this.questionId,
          content: this.reportForm.reportContent,
          type: 2,
          reason: this.reportForm.reportReasonArray.join()
        }
        this.$http
          .post("/api/u/report", form)
          .then(response => {
            if (response.code == "OK") {
              this.$message(this.$t("global.举报成功"));
              this.close();
              this.init();
            } else {
              this.$message(this.$t("global.举报失败"));
            }
          });
      }
    },
    close() {
      this.$emit("close-after", this.item);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-dialog {
  position: absolute;
  width: 418px !important;
  height: 422px !important;
  top: 50%;
  left: 50%;
  margin: -211px 0 0 -209px !important;
}

.el-textarea {
  width: 100% !important;
}

.el-dialog .el-checkbox:last-child {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/topic/ReportDialog.vue